import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";
import { capitalize } from "../../../../../lib/html5-software-library/src/ranj/util/StringUtil";

export default class MapLocationButton extends Button {
    constructor(skin) {
        super(skin);
    }

    _setState(state) {
        super._setState(state);
        this._setStateForImage(state);
    }

    _newCharacterAvailable() {
        this.target.NewCharacterAvailable.alpha = 1;
    }

    _noCharacterAvailable() {
        this.target.NewCharacterAvailable.alpha = 0;
    }

    _setStateForImage(state) {
        let newState = state;
        if (this.getSelected()) {
            newState = "selected" + capitalize(newState);
        }
        this.skin.locationImage.gotoAndStop(newState);
    }
}